export default __webpack_public_path__ + "static/media/increase.5a8cc556.svg";